import type { TableRecord } from '@/utils/table/types';

import type { WidgetDataSource } from '../gigawidget/types';

export const createDataSource = <
  TItem extends TableRecord,
  TArgs,
  TData extends { __typename?: 'query_root' },
>(
  config: WidgetDataSource<TItem, TArgs, TData>
) => config;
